import Icon from '../components/Icon.vue'

Icon.register({
  'balance-scale': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M256 336H256C256 319.8 257.3 327.3 170.9 154.5 153.3 119.2 102.7 119.1 85.1 154.5-2.1 328.8 0 320.3 0 336H0C0 380.2 57.3 416 128 416S256 380.2 256 336zM128 176L200 320H56L128 176zM640 336C640 319.8 641.3 327.3 554.9 154.5 537.3 119.2 486.7 119.1 469.1 154.5 381.9 328.8 384 320.3 384 336H384C384 380.2 441.3 416 512 416S640 380.2 640 336H640zM440 320L512 176 584 320H440zM528 448H352V153.3C375.5 143 393.2 121.8 398.4 96H528C536.8 96 544 88.8 544 80V48C544 39.2 536.8 32 528 32H383.6C369 12.7 346.1 0 320 0S271 12.7 256.4 32H112C103.2 32 96 39.2 96 48V80C96 88.8 103.2 96 112 96H241.6C246.8 121.8 264.5 143 288 153.3V448H112C103.2 448 96 455.2 96 464V496C96 504.8 103.2 512 112 512H528C536.8 512 544 504.8 544 496V464C544 455.2 536.8 448 528 448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/balance-scale.js
// module id = JhwS
// module chunks = 144